import { createReducer } from '@reduxjs/toolkit';
import { deleteQueryData, saveQueryData } from './query.actions';

type QueryData = {
  data?: any;
  timestamp: string;
  status?: 'idle' | 'pending' | 'success' | 'error';
};

const initialState: Record<string, QueryData | undefined> = {};

const queryReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(saveQueryData, (state, action) => {
      const {
        payload: { queryKey, data, status },
      } = action;

      const query = state[queryKey];

      state[queryKey] = {
        ...query,
        data,
        status,
        timestamp: new Date().toISOString(),
      };
    })
    .addCase(deleteQueryData, (state, action) => {
      const {
        payload: { queryKey },
      } = action;
      delete state[queryKey];
    }),
);

export default queryReducer;
